<template>
  <div class="swiper">
    <div
      style="
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        margin-bottom: 15px;
        font-weight: bold;
      "
    >
      <div style="width: auto; padding-left: 20px">排名</div>
      <div style="width: auto; padding-left: 10px">城市名称</div>
      <div style="width: auto; text-align: right">{{ year ? '商标申请量' : '历年申请量' }}</div>
    </div>
    <transition-group name="list-complete" tag="div" class="list-wrap">
      <div
        v-for="(item, index) in list"
        :key="item.index"
        class="swiper-slide list-complete-item"
        :style="{ color: index % 2 === 0 ? '#fff' : '#BDBDBD' }"
      >
        <div style="font-size: 50px; position: absolute; left: 0; top: -26px">
          ·
        </div>
        <div style="margin-left: 30px; margin-right: 15px; width: 30px">
          {{ item.index }}
        </div>
        <div style="width: 180px">{{ item.name }}</div>
        <div>{{ item.value }}</div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "swiper-list2",
  data() {
    return {
      list: [],
    };
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    // 根据选择器来变换标题
    year: {
      type: String,
      default: () => "",
    },
  },
  watch: {
    data(e) {
      this.list = e.map((i, index) => {
        return { ...i, index: index + 1 };
      });
      // console.log(e);
    },
  },
  mounted() {
  // console.log(this.data)
    this.timer = setInterval(() => {
      let arr = [...this.list];
      arr.push(arr[0]);
      arr.shift(arr);
      this.list = arr;
    }, 3000);
  },
};
</script>

<style scoped>
.swiper {
  width: 250px;
  height: 30px;
}
.list-item {
  /*display: inline-block;*/
  margin-right: 10px;
}

.list-complete-item {
  transition: all 0.2s ease;
  height: 30px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  position: relative;
}
.list-complete-enter, .list-complete-leave-to
  /* .list-complete-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.list-complete-leave-active {
  position: absolute;
  opacity: 0;
}
.list-wrap {
  height: 150px;
  overflow: hidden;
}
</style>